import React from "react";
import { Link } from "react-router-dom";
import "./ProfileBio.css";

const ProfileBio = ({
  currentProfile,
  upvoteBadgeHandler,
  answerBadgeHandler,
  existingUpvoteBadge,
  existingAnswerBadge,
}) => {
  return (
    <div className="profile-bio">
      <div>
        {currentProfile?.tags.length !== 0 ? (
          <>
            <h4>Tags watched</h4>
            {currentProfile?.tags.map((tag) => (
              <p key={tag}>{tag}</p>
            ))}
          </>
        ) : (
          <p>0 Tags watched </p>
        )}
      </div>
      <div>
        {currentProfile?.about ? (
          <>
            <h4>About</h4>
            <p>{currentProfile?.about}</p>
          </>
        ) : (
          <p>No bio found</p>
        )}
      </div>
      <div className="badge-check">
        <p className="badge-check-text">
          Check whether you got most number of Upvotes 👉{" "}
          <button className="badge-button" onClick={upvoteBadgeHandler}>
            Click Here
          </button>
        </p>
        <p className="badge-check-text">
          Check whether you gave most number of Answers 👉
          <button className="badge-button" onClick={answerBadgeHandler}>
            Click Here
          </button>
        </p>
        <p className="tc-text">
          Please read the <Link to="/BadgeTC">Terms and Conditions</Link> for
          getting a badge.
        </p>
        <div className="badge-display">
          {existingUpvoteBadge ? (
            <>
              <h4>Badge earned for UpVotes</h4>
              <p className="badge">{existingUpvoteBadge.toUpperCase()}</p>
            </>
          ) : (
            <p>No Badge found.</p>
          )}
          {existingAnswerBadge ? (
            <>
              <h4>Badge earned for Answers</h4>
              <p>
                <p className="badge">{existingAnswerBadge.toUpperCase()}</p>
              </p>
            </>
          ) : (
            <p>No Badge found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileBio;
